import { checkDuplicateOverChargeClaimDetailsEffect } from '@/redux/Claims/OverCharge/OverChargeEffects';
import { convertBlobToBase64 } from '@/utils/file';
import EmptyRecords from '@/views/components/Common/EmptyRecords';
import AlertModal from '@/views/components/Modals/AlertModal';
import ScrollPagination from '@/views/components/Paginations/ScrollPagination';
import { Col, Divider, Form, Row } from 'antd';
import { cloneDeep } from 'es-toolkit';
import { useEffect, useMemo, useState } from 'react';
import Files from 'react-files';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as FileIcon } from '../../../../../../../../assets/icons/files-records.svg';
import {
  applyClaimRecoveryPercentInProgress,
  getOCClaimItemsInProgress,
  getOverChargeItemsFromExcelInProgress,
  updateOverChargeClaimInProgress,
} from '../../../../../../../../redux/Claims/OverCharge/OverChargeActions';
import { setAppLoader, setWarningModal } from '../../../../../../../../redux/common/CommonActions';
import { formateAmount } from '../../../../../../../../utilz';
import {
  checkDuplicateOverchargeItem,
  overChargeClaimsItemsSectionLocalToAPI,
} from '../../../../../../../../utilz/OverChargeClaimUtils';
import { convertDateStringtoMoment } from '../../../../../../../../utilz/dates';
import VerticalLine from '../../../../../../../components/Bars/VerticalLine';
import Button from '../../../../../../../components/Buttons/Button';
import SvgConverter from '../../../../../../../components/Common/SvgConverter';
import FormInput from '../../../../../../../components/Inputs/FormInput';
import PrimaryLabel from '../../../../../../../components/Labels/PrimaryLabel';
import Paper from '../../../../../../../components/Paper/Paper';
import FooterContentCard from '../../../../../../common/FooterContentCard';
import OverChargeClaimEmailDetailsModal from '../OverChargeDetails/OverChargeClaimEmailDetailsModal';
import OverChargeItemsCard from './OverChargeItemsCard';
import OverChargeUploadItemsModal from './OverChargeUploadItemsModal';

const OverChargeItems = () => {
  const dispatch = useDispatch();
  const claimDetails = useSelector((state) => state.overChargeClaims.claimDetails);
  const itemsFromExcel = useSelector((state) => state.overChargeClaims.itemsFromExcel);
  const claimItems = useSelector((state) => state.overChargeClaims.claimItems);
  const applyClaimRecoveryPercent = useSelector((state) => state.overChargeClaims.applyClaimRecoveryPercent);

  const [itemList, setItemList] = useState([]);
  const [emailDetailsModal, setEmailDetailsModal] = useState(false);
  const [uploadModal, setUploadModal] = useState(false);
  const [overchargePercentForm] = Form.useForm();
  const [pageIndex, setPageIndex] = useState(1);
  const [duplicateClaimText, setDuplicateClaimText] = useState(false);

  useEffect(() => {
    if (claimItems?.data) {
      setItemList(
        claimItems.data.map((row) => ({
          ...row,
          shipDate: convertDateStringtoMoment(`${row.shipDate}Z`),
          isNew: false,
          editMode: false,
        })),
      );
    }
  }, [claimItems?.data]);

  const handleAddNew = () => () => {
    let itemListLocal = cloneDeep(itemList);
    itemListLocal = [
      {
        fbOcKey: claimDetails.data.fbOcKey,
        dirtyFlag: 'i',
        itemID: 0,
        proNo: undefined,
        invoiceNumber: undefined,
        packageNumber: undefined,
        shipDate: undefined,
        weight: 0,
        billedAmount: 0,
        paidAmount: 0,
        correctCharges: 0,
        overchargeAmount: 0,
        recoveryAmount: 0,
        isNew: true,
        editMode: true,
      },
      ...itemListLocal,
    ];
    setItemList(itemListLocal);
  };

  const setEditMode = (index, val) => {
    const itemListLocal = cloneDeep(itemList);
    itemListLocal[index].editMode = val;
    setItemList(itemListLocal);
  };

  const handleCancel = (index, isNew) => () => {
    const itemListLocal = cloneDeep(itemList);
    if (isNew) {
      itemListLocal.splice(index, 1);
    } else {
      itemListLocal[index] = {
        ...itemListLocal[index],
        // ...claimDetails?.data?.claimItem[index],
        editMode: false,
      };
    }
    setItemList(itemListLocal);
  };

  const handleSubmit = async (data) => {
    try {
      dispatch(setAppLoader(true));
      const claimDetailsLocal = cloneDeep(claimDetails.data);
      claimDetailsLocal.claimItem = [{ ...data, dirtyFlag: data.isNew ? 'I' : 'U' }];
      const formData = overChargeClaimsItemsSectionLocalToAPI(claimDetailsLocal);
      const { data: duplicateValue } = await checkDuplicateOverChargeClaimDetailsEffect(formData);
      const { isHavingDuplicateItem, duplicateMessage } = checkDuplicateOverchargeItem(
        formData.claimItem,
        String(duplicateValue),
      );
      if (isHavingDuplicateItem) {
        dispatch(setAppLoader(false));
        setDuplicateClaimText(duplicateMessage);
        return;
      }
      formData.section = 'ITEMS';
      formData.isRefetchDetails = true;
      formData.pageIndex = pageIndex;
      dispatch(updateOverChargeClaimInProgress(formData));
    } catch (error) {
      console.log(error);
    }
  };

  const handleDelete = (index) => () => {
    const claimDetailsLocal = cloneDeep(claimDetails.data);
    claimDetailsLocal.claimItem = [{ ...itemList[index], dirtyFlag: 'D' }];
    claimDetailsLocal.section = 'ITEMS';
    claimDetailsLocal.isRefetchDetails = true;
    claimDetailsLocal.pageIndex = pageIndex;
    dispatch(updateOverChargeClaimInProgress(claimDetailsLocal));
  };

  const overChargePercent = Form.useWatch('overChargePercent', overchargePercentForm);

  const handleOverChargePercentCalculation = () => {
    dispatch(
      applyClaimRecoveryPercentInProgress({
        fbOcKey: claimDetails.data.fbOcKey,
        percentage: overChargePercent,
        pageIndex,
      }),
    );
  };

  const isEditing = useMemo(() => {
    let value = false;
    value = itemList?.filter(({ editMode }) => editMode)?.length > 0;
    return value;
  }, [itemList]);

  const handleUploadFile = async (data) => {
    try {
      const handleSuccess = () => {
        setUploadModal(true);
      };
      dispatch(setAppLoader(true));
      const file = await convertBlobToBase64(data[0]);
      dispatch(
        getOverChargeItemsFromExcelInProgress({
          file: file.split(',')[1],
          fbocKey: claimDetails?.data?.fbOcKey,
          handleSuccess,
        }),
      );
    } catch {
      dispatch(setAppLoader(false));
      dispatch(
        setWarningModal({
          open: true,
          description: 'Invalid file,  Please verify the selected file.',
        }),
      );
    }
  };

  const handleUploadFileError = (e) => {
    dispatch(setWarningModal({ open: true, description: e?.message }));
  };

  const handleUploadApply = (excelSheetItems) => {
    const items = excelSheetItems.map((row) => {
      const paidAmountL = row.paidAmount ? row.paidAmount : 0;
      const correctChargesL = row.correctCharges ? row.correctCharges : 0;
      let diffAmount = 0;
      diffAmount = paidAmountL - correctChargesL;
      diffAmount = diffAmount >= 0 ? diffAmount : diffAmount * -1;
      return { ...row, overchargeAmount: diffAmount };
    });
    const itemListExcel = items.map((row) => ({ ...row, dirtyFlag: 'I' }));
    const claimDetailsLocal = cloneDeep(claimDetails.data);
    const formData = overChargeClaimsItemsSectionLocalToAPI(claimDetailsLocal);
    formData.claimItem = itemListExcel;
    formData.handleSuccess = () => {
      setUploadModal(false);
    };
    formData.section = 'ITEMS';
    formData.isRefetchDetails = true;
    formData.pageIndex = pageIndex;
    formData.uploadedFromExcel = true;
    dispatch(updateOverChargeClaimInProgress(formData));
  };

  useEffect(() => {
    if (claimDetails.data?.fbOcKey) {
      dispatch(
        getOCClaimItemsInProgress({
          fbOcKey: claimDetails.data.fbOcKey,
          pageIndex,
        }),
      );
    }
  }, [claimDetails.data?.fbOcKey]);

  const handleNextPage = () => {
    if (claimDetails.data?.fbOcKey) {
      const nextPageNo = pageIndex + 1;
      dispatch(
        getOCClaimItemsInProgress({
          fbOcKey: claimDetails.data.fbOcKey,
          pageIndex: nextPageNo,
        }),
      );
      setPageIndex(nextPageNo);
    }
  };

  return (
    <div className="d-flex  py-16 h-100" style={{ flexDirection: 'column' }}>
      <Row className="px-30 align-items-center" justify="space-between">
        <Col>
          <PrimaryLabel className="fw-700 f-18">Over Charge Claims Items</PrimaryLabel>
        </Col>
        <Col>
          <Row justify="end" gutter={16} align="middle">
            <Col>
              <Button onClick={handleAddNew()}>Add New Item</Button>
            </Col>
            <Col>
              <Files
                className="files-dropzone"
                onChange={handleUploadFile}
                onError={handleUploadFileError}
                accepts={['.xls', '.xlsx']}
                multiple={false}
                // maxFileSize={10000000}
                minFileSize={0}
                clickable
              >
                <Button>
                  <SvgConverter Icon={FileIcon} color="white" width={16} height={16} className="mr-5" />
                  Upload File
                </Button>
              </Files>
            </Col>
            <Col>
              <Button onClick={() => setEmailDetailsModal(true)}>View Email Status</Button>
            </Col>
            <Col>
              <Form form={overchargePercentForm}>
                <FormInput name="overChargePercent" inputType="number" editMode margin="m-0" placeholder=" " />
              </Form>
            </Col>
            <Col>
              <Button
                disabled={
                  claimDetails.data.statusCode === 'C'
                    ? !overChargePercent || overChargePercent > 100 || isEditing
                    : true
                }
                onClick={handleOverChargePercentCalculation}
                loading={applyClaimRecoveryPercent.progressing}
              >
                Apply
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
      <Divider className="mt-0 my-16 ml-n16 vw-100 " />
      {itemList.length > 0 || claimItems.progressing ? (
        <ScrollPagination
          className="px-30 my-10 flex-1"
          loadMore={handleNextPage}
          isLoading={claimItems.progressing}
          hasMore={claimItems.data?.length < claimItems.totalRows}
          scrollOffset={30}
        >
          {itemList.map((row, index) => (
            <OverChargeItemsCard
              noteDetails={row}
              key={row.itemID}
              index={index}
              editMode={Boolean(row.editMode)}
              setEditMode={setEditMode}
              handleCancel={handleCancel}
              handleSubmit={handleSubmit}
              handleDelete={handleDelete}
            />
          ))}
        </ScrollPagination>
      ) : (
        <EmptyRecords />
      )}
      <div className="px-30">
        <Paper className="background-header px-16 py-5">
          <Row justify="space-around" className="px-10" gutter={10}>
            <Col>
              <FooterContentCard
                reverse
                align="middle"
                count={formateAmount(claimItems.totalBilledAmount)}
                label="Billed Amount"
                contentClass="text-white f-16 fw-600"
                labelClass="text-light f-14"
              />
            </Col>
            <Col>
              <VerticalLine />
            </Col>
            <Col>
              <FooterContentCard
                reverse
                align="middle"
                count={formateAmount(claimItems.totalPaidAmount)}
                label="Paid Amount"
                contentClass="text-white f-16 fw-600"
                labelClass="text-light f-14"
              />
            </Col>
            <Col>
              <VerticalLine />
            </Col>
            <Col>
              <FooterContentCard
                reverse
                align="middle"
                count={formateAmount(claimItems.totalCorrectCharges)}
                label="Correct Charges"
                contentClass="text-white f-16 fw-600"
                labelClass="text-light f-14"
              />
            </Col>
            <Col>
              <VerticalLine />
            </Col>
            <Col>
              <FooterContentCard
                reverse
                align="middle"
                count={formateAmount(claimItems.totalOverchargeAmount)}
                label="Overcharge Sum"
                contentClass="text-white f-16 fw-600"
                labelClass="text-light f-14"
              />
            </Col>
            <Col>
              <VerticalLine />
            </Col>
            <Col>
              <FooterContentCard
                reverse
                align="middle"
                count={formateAmount(claimItems.totalRecoveryAmount)}
                label="Recovery Sum"
                contentClass="text-white f-16 fw-600"
                labelClass="text-light f-14"
              />
            </Col>
          </Row>
        </Paper>
      </div>
      <OverChargeClaimEmailDetailsModal
        open={emailDetailsModal}
        setOpen={setEmailDetailsModal}
        fbocKey={claimDetails?.data?.fbOcKey}
      />
      <OverChargeUploadItemsModal
        open={uploadModal}
        setOpen={setUploadModal}
        items={itemsFromExcel?.data ? itemsFromExcel?.data : []}
        handleApply={handleUploadApply}
      />
      <AlertModal
        open={Boolean(duplicateClaimText)}
        description={duplicateClaimText}
        onOk={() => setDuplicateClaimText(false)}
      />
    </div>
  );
};

export default OverChargeItems;
